import { DataProvider } from '@/@types/data_provider';
import { globalVar } from './globals';

let dataProviderMap: Map<string, DataProvider> | null = null;

function getProviderMap(): Map<string, DataProvider> {
    if (!dataProviderMap) {
        const dataProviders = (globalVar('data_providers') || []) as DataProvider[];
        dataProviderMap = new Map<string, DataProvider>();
        dataProviders.forEach((dp) => {
            if (dataProviderMap) {
                // we fill the map with both the uuid and id as key.
                // this leads to more memory usage, but allows searching by id or uuid.
                dataProviderMap.set(dp.uuid, dp);
                dataProviderMap.set(dp.id, dp);
            }
        });
    }
    return dataProviderMap;
}

/**
 * Looks up an Azizi DataProvider entry (see config.php, azizi.export.dataProviders)
 * either by id or uuid.
 *
 * @param key id or uuid of a DataProvier
 * @returns {id: string, uuid: string, provider: string} | null
 */
export function lookupDataProvider(key: string): DataProvider | null {
    return getProviderMap().get(key) ?? null;
}
